<template>

    <b-modal id="apprentice-ratio-modal" ref="apprenticeRatioRef" v-model="show" centered
        modal-class="a4-portrait no-header no-footer">
        <div class="p-1 overflow-auto h-100 p-relative">
            <div class="floating-header">
                <a href="#" class="bg-white d-block px-2 py-1 text-orange">Download PDF</a>
                <a href="#" class="bg-white d-block px-2 py-1 ml-1 text-orange" @click="show = false">
                    <i class="fa fa-times" />
                </a>
            </div>
            <div class="d-flex align-items-center p-3 justify-content-start">
                <h5 class="text-nowrap">Apprentice Ratio Report</h5>
                <b-select v-model="selected_week" :options="week_options" class="ml-4 flex-shrink-1 w-auto"></b-select>
            </div>

            <div class="table-responsive p-3">
                <table class="table">
                    <tr class="text-primary">
                        <td>Date</td>
                        <td style="width: 250px;">Trade</td>
                        <td>Journey/Apprentice Ratio</td>
                        <td>On Site</td>
                    </tr>
                    <tr v-for="(value, day) in weekly_apprentice_rates[selected_week]" :key="day"
                        class="border-bottom border-dark">
                        <td>{{ day }}</td>
                        <td colspan="2">
                            <table class="table table-sm">
                                <tr v-for="(worker_type, index) in get_fake_ratio()" class="border-bottom" :key="index">
                                    <td style="width: 250px">{{ worker_type.label }}</td>
                                    <td>{{ worker_type.journeymen }}/{{ worker_type.apprentices }}</td>
                                </tr>
                            </table>
                        </td>
                        <td>
                            <table class="table table-sm">
                                <tr v-for="company in companies" :key="company.id">
                                    <td>{{ company.title }}</td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </div>

        </div>
    </b-modal>
</template>
<script>
import { mapState } from 'vuex';
import faker from 'faker';

export default {
    name: 'ApprenticeRatio',
    computed: {
        ...mapState(['workers', 'companies']),
        apprentice_rates() {
            return this.$store.state.report.apprentice_rates;
        },
        weekly_apprentice_rates() {
            const weekly_rates = [];
            const chunks = this.$finder.chunk(Object.keys(this.apprentice_rates), 7);
            for (let week_index in chunks) {
                const dates = chunks[week_index];
                weekly_rates[week_index] = {};
                for (let date of dates) {
                    weekly_rates[week_index][date] = this.apprentice_rates[date];
                }

            }

            return weekly_rates;
        },
        week_options() {
            return this.weekly_apprentice_rates.map((rate, index) => {
                const key = `${Object.keys(rate)[0]} - ${Object.keys(rate)[6]}`;
                return { value: index, text: key }
            });
        }
    },
    data() {
        return {
            selected_week: "0",
            faker: faker,
            show: false,
        }
    },
    methods: {
        get_fake_ratio() {
            const types = this.$config.worker_types
            return Object.keys(types).map(key => {
                const p = Math.random();
                if (p < 0.2) return { label: types[key].label, apprentices: 0, journeymen: 0 }
                const apprentices = faker.datatype.number({ min: 10, max: 20 });
                const journeymen = 100 - apprentices
                return { label: types[key].label, apprentices, journeymen }
            });
        },
    }
}
</script>